import { render } from "./OfficeScreen.vue?vue&type=template&id=53391f59&ts=true&lang=pug"
import script from "./OfficeScreen.vue?vue&type=script&lang=ts"
export * from "./OfficeScreen.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__